import gql from 'graphql-tag';

export const getAllReferralCodeByAdmin = gql`
  query getAllReferralCodeByAdmin{
    getAllReferralCodeByAdmin{
      id
      code
      consumer{
        id
        username
      }
      merchant { 
        id 
        username
      }
      referalCodeType
      offer{
        id
        title
      }
      active
      listUserEnterCode{
        id
        createdAt
        transactions { createdAt }
        username
        usageCount
        totalUsageCount
      }
    }
  }
`;
